module.exports = __webpack_public_path__ + "img/vrt_banner.f94105eb.png";